import React from 'react'
import { useFormik } from 'formik'
import { object, string } from 'yup'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { db, auth } from '../firebase-config'
import { setDoc, doc, collection, Timestamp } from 'firebase/firestore'
import { Button } from '../components/Button'
import { Input } from '../components/Input'
import { Error } from '../components/Error'
import { Textarea } from '../components/Textarea'
import styles from './UserSignUp.module.css'

const requiredMsg = 'Dieses Feld ist verpflichtend'

const profileSchema = object({
  title: string().min(3, 'mindestens 3 Zeichen').required(requiredMsg),
  content: string().required(requiredMsg),
})

const initialValues = {
  title: '',
  content: '',
  contact: '',
  timestamp: '',
  author: '',
}

const entryRef = doc(collection(db, 'news'))

async function handleSubmit(values) {
  try {
    setDoc(entryRef, {
      title: values.title,
      content: values.content,
      contact: values.contact,
      timestamp: Timestamp.now(),
      author: auth.currentUser.email,
    }).then(() => {
      window.location.href = '/news'
    })
  } catch (error) {
    toast.error(
      'Leider konnten wir deinen Beitrag nicht erstellen. Bitte versuche es erneut.',
      {
        position: 'top-center',
      },
    )
  }
}

export const CreateNews = ({ onSubmit = handleSubmit }) => {

  const formik = useFormik({
    initialValues,
    validationSchema: profileSchema,
    onSubmit: (values) => {
      onSubmit(values)
    },
  })

  return (
    <form className={styles.usersignup} onSubmit={formik.handleSubmit}>
      <div>
        <Input
          name='title'
          type='text'
          label='Überschrift'
          placeholder='Bauernmarkt in Salzburg'
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.title}
        />
        {formik.touched.title && formik.errors.title && (
          <Error msg={formik.errors.title} />
        )}
      </div>
      <div>
        <Textarea
          name='content'
          type='text'
          label='Inhalt'
          placeholder='Am Montag findet der Bauernmarkt in Salzburg um 12:00 statt'
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.content}
        />
        {formik.touched.content && formik.errors.content && (
          <Error msg={formik.errors.content} />
        )}
      </div>
      <div>
      <Textarea
          name='contact'
          type='text'
          label='Kontaktdaten (optional)'
          placeholder='Für weitere Informationen kontaktieren Sie bitte diese Nummer: 0463 254168 8'
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.contact}
        />
        {formik.touched.contact && formik.errors.contact && (
          <Error msg={formik.errors.contact} />
        )}
      </div>

      <Button type='submit'>Beitrag erstellen</Button>
    </form>
  )
}
